<template>
  <div v-if="bodyShow" class="ms-my-main">
    <!-- header -->
    <div class="my-header">
        <img :src="userInfo.headimgurl" alt="">
        <h2>
            {{userInfo.nickname}} <span style="font-size: xx-small;">({{userInfo.id}})</span>
        </h2>
    </div>
    <!-- 功能区 -->
    <div class="my-areas">
        <a @click="toNextPage('/ms_report_list')" class="areas-menu">
            <img src="@a/ms_system/report.png" alt="">
            <h3>我的报告</h3>
        </a>
        <a @click="toNextPage('/my_personal_settings')"  class="areas-menu">
            <img src="@a/ms_system/set-up.png" alt="">
            <h3>个人设置</h3>
        </a>
        <a href="https://jinshuju.net/f/lC468Z"  class="areas-menu">
            <img src="@a/ms_system/feedback.png" alt="">
            <h3>意见反馈</h3>
        </a>
    </div>

    <div v-if="is_snapshot" class="goods-btn-group">
        <a class="pay-button" @click="get_userinfo">微信登录</a>
    </div>
    <!-- 未完成测评 -->
    <div class="ms-unfinished" v-else>
        <h2>未完成测评</h2>
        <ul>
            <li class="unfinished-list" v-for="(item,index) in my_ceping" :key="index">
                <img :src="item.image" >
                <div class="unfinished-text">
                    <h3>{{item.name}}</h3>
                    <p ><span v-if="item.update_time">上次测评：</span>{{item.update_time}}</p>
                    <h4>
                        <span class="left">完成 {{item.progress}}%</span>
                        <span class="right" @click="toCeping(item.link)">继续测评<img src="@a/ms_system/my-right.png" alt=""></span>
                    </h4>
                </div>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>

import { my } from "@/api/measurement_system";
import { goAuthLogin } from "@u/tools";
export default {
    data(){
        return{
            bodyShow:false,
            data:{},
            my_ceping:[],
            userInfo:{},
            is_snapshot: true
        }
    },
    methods:{
        get_userinfo() {
          goAuthLogin('微信登录获取头像昵称', null, 'snsapi_userinfo');
        },
        /*
         *@param: nextPage 跳转页面路由
         *@Description: 跳转新页面
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-12 14:25:27
        */
        toNextPage(nextPage){
            this.$router.push(nextPage);
        },
        /*
         *@Description: 点击跳转测评
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-11 18:09:21
        */
        toCeping(link){
            // 判断是否填写资料，取其中的城市判断
            if(this.data.info.city){
                this.$router.push('/ms_information?link='+encodeURIComponent(link));
            }else{
                this.$router.push(link);
            }
        },
        /*
         *@Description: 初始化请求数据
         *@MethodAuthor:  Zhang Xiao Guang
         *@Date: 2019-12-11 18:08:59
        */
        pullData(){
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            my().then((data)=>{
                this.data= data;
                this.is_snapshot = data.is_snapshot;
                this.userInfo =data.user;
                this.my_ceping =data.my_ceping;
                this.bodyShow = true;
                this.$toast.clear();
            });
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.goods-btn-group{
    width: 100%;
    max-width: 750px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    .pay-button {
      background-color: #eb5032;
      color: #ffffff;
      font-size: 34px;
      text-align: center;
      line-height: 98px;
      flex: 1;
      &:first-child{
        border-right: 2px solid #ffffff;
      }
      &.btn-orange {
        background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
      }
    }
}

.ms-my-main{
    display: flex;
    background: #f0f0f0;
    flex-direction: column;
    position: absolute;
    width: 100%;
    height: 100%;
    .my-header{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 284px;
        background-color: #EB5032;
        img{
            width: 100px;
            height: 100px;
            border-radius: 50%;
            background-color: #ffffff;
        }
        h2{
            font-size: 32px;
            color: #ffffff;
            margin-top: 26px;
        }
    }
    // 功能区
    .my-areas{
        display: flex;
        height: 185px;
        justify-content:center;
        background-color: #ffffff;
        align-items: center;
        margin-bottom: 30px;
        .areas-menu{
            display: block;
            text-align: center;
            color: #333333;
            font-size: 26px;
            &:nth-child(2){
                margin: 0 132px;
            }
            img{
                width: 60px;
                height: 60px;
            }
            h3{
                line-height: 1;
                margin-top: 16px;
            }
        }
    }
    // 未完成测评
    .ms-unfinished{
        // height: 647px;
        flex: 1;
        background-color: #ffffff;
        // padding-bottom: 40px;
        overflow: auto;
        h2{
            font-size: 32px;
            color: #333333;
            margin:30px 30px 0 30px;
        }
        .unfinished-list{
            display: flex;
            padding: 30px;
            border-bottom: 1px solid #CCCCCC;
            &:last-child{
                border-bottom: 0;
            }
            img{
                width: 200px;
                height: 150px;
                margin-right: 20px;
            }
            .unfinished-text{
                width: 100%;
                display: flex;
                flex-direction: column;
                h3{
                    font-size: 30px;
                    color: #333333;
                    line-height: 1;
                    font-weight: bold;
                }
                p{
                    margin-top: 15px;
                    font-size: 24px;
                    min-height: 23px;
                    line-height: 1;
                    color: #666666;
                }
                h4{
                    display: flex;
                    font-size: 28px;
                    color: #F57F17;
                    margin-top: 58px;
                    line-height: 1;
                    .left{
                        margin-right: auto;
                    }
                    .right{
                        display: flex;
                        align-items: center;
                        img{
                            margin-left: 6px;
                            width: 13px;
                            height: 25px;
                        }
                    }
                }
            }
        }
    }
}

</style>